// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3bwMN","inner":"Form_inner__2DKzH","range":"Form_range__oyrFm","name":"Form_name__2vJ6O","actions":"Form_actions__acwrq"};